import { render } from "./SendEmails.vue?vue&type=template&id=50be5a45&scoped=true"
import script from "./SendEmails.vue?vue&type=script&lang=js"
export * from "./SendEmails.vue?vue&type=script&lang=js"

import "./SendEmails.vue?vue&type=style&index=0&id=50be5a45&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50be5a45"]])

export default __exports__